import React from "react"

const renderOptions = (options: string[]) => {
  return options.map((value, index) => <option key={index}>{value}</option>)
}

interface Props {
  options: string[]
  value: string
  onChange?: (tag: string) => void
}

const TagSelect = ({ options, value, onChange }: Props) => {
  const onChangeWrapper = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange && onChange(event.target.value)
  }

  return (
    <select
      className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
      id="grid-state"
      onChange={onChangeWrapper}
      value={value}
    >
      {renderOptions(options)}
    </select>
  )
}

export default TagSelect
